import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import apiReducer from './apiSlice';
import dashboardApiReducer from './dashboardForUserId';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistStore } from 'redux-persist';
import thunk from "redux-thunk";

const devToolsCompose = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

const reducers = combineReducers({
  apiDashboard: apiReducer,
  apiDashboardForUserId: dashboardApiReducer
});
// export const setupStore = (preloadedState?: Partial<RootState>) => {
//   return store;
// };
const vyuDashboardPersistConfig = {
    key: "dashboards",
    storage: storage,
  };

  // export const createPreloadedState = (
  //   customState: Partial<RootState>
  // ): Partial<RootState> => {
  //   return {
  //     apiDashboard: { ...store.getState().apiDashboard, ...customState.apiDashboard },
  //     apiDashboardForUserId: { ...store.getState().apiDashboardForUserId, ...customState.apiDashboardForUserId }
  //   };
  // };
const persistedReducer = persistReducer(vyuDashboardPersistConfig, reducers);
 const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
  middleware : (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]},
    }),
});

export type RootState = ReturnType<typeof store.getState>;
// export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = typeof store.dispatch;
export const persistor= persistStore(store);
export default  store ;
